var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"c-filters__button c-filters__button--icon",class:[_vm.isActive ? 'is-active' : ''],on:{"click":_vm.toggleClass}})])}
var staticRenderFns = []

export { render, staticRenderFns }